import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "text-primary fw-normal border border-lightgray border-top-0 border-start-0 border-end-0 pb-3 my-5" }, " Sound: ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  type: "file",
  accept: "audio/mp3",
  class: "custom-file-input btn btn-primary rounded-pill"
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "text-secondary ms-3 py-2"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-secondary mt-2" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Please upload a file in .mp3")
], -1)
const _hoisted_5 = {
  key: 1,
  class: "mt-5 text-secondary"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Preview \"Name of media\":", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("audio", { controls: "" }, [
  /*#__PURE__*/_createElementVNode("source", {
    src: "http://commondatastorage.googleapis.com/codeskulptor-assets/week7-button.m4a",
    type: "audio/mp3"
  }),
  /*#__PURE__*/_createTextVNode(" Your browser does not support the audio element. ")
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    true
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Media uploaded!"))
      : _createCommentVNode("", true),
    _hoisted_4,
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}